<template>
  <table class="table table-striped table-bordered">
    <thead>
      <tr>
        <th
          v-for="(item, key, index) in columnTitles"
          :key="index"
          style="word-break: keep-all"
        >
          {{ item }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, key) in itemList" :key="key">
        <td>{{ item[0] }}</td>
        <td>{{ item[1] }}</td>
        <td>
          <span v-for="(tag, key2) in item[2]" :key="key2" class="tag">
            {{ tag[1] }}
            <a @click="deleteTag(item[0], tag[0])" href="#">x</a>
          </span>
          <div class="input-form list-group">
            <input
              ref="iptag"
              v-model="inputForm[item[0]]"
              :placeholder="placeholder"
              @focus="dispSuggest(item[0])"
              @keyup="searchSuggest(item[0])"
              @keydown.enter="postTag(item[0], key, $event)"
              type="text"
            />
            <div v-show="displaySuggest[item[0]]" class="suggest">
              <div class="suggest-list">
                <a
                  v-for="(tags, key2) in tagSuggest"
                  :key="key2"
                  :value="tags[0]"
                  @click="inputSuggest(item[0], tags[0], tags[1])"
                  class="list-group-item list-group-item-action"
                  href="#"
                >
                  {{ tags[1] }}
                </a>
              </div>
              <a @click="cancel" class="aut-but">
                <font-awesome-icon icon="times-circle" />
              </a>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import Search from '@/utility/WordSearch'
export default {
  props: ['columnTitles', 'items', 'suggests', 'placeholder', 'searchString'],
  data() {
    return {
      itemList: [], // アイテム
      tagSuggest: [], // タグのサジェスト
      inputForm: {}, // 入力した内容
      displaySuggest: {}, // サジェストの表示切替
    }
  },
  watch: {
    items: function(newItems) {
      if (this.searchString === '') {
        this.itemList = newItems
      } else {
        this.itemList = Search.searchFromCollection(newItems, this.searchString)
      }
      this.initializeInput()
      this.initializeSuggest()
    },
    suggests: function(newSuggests) {
      this.tagSuggest = newSuggests
    },
    searchString: function(newString) {
      this.itemList = Search.searchFromCollection(this.items, newString)
    },
  },
  methods: {
    // 紐づけ削除
    deleteTag: function(itemId, tagId) {
      this.$emit('deleteTag', itemId, tagId)
    },
    // タグ送信
    postTag: function(itemId, index, event) {
      // 文字入力中のenterを無効
      if (event.keyCode !== 13) {
        return
      }

      this.displaySuggest[itemId] = false
      this.$refs.iptag[index].blur()
      this.$forceUpdate()

      if (
        this.inputForm[itemId] === undefined ||
        this.inputForm[itemId] === ''
      ) {
        return
      }
      this.$emit('postTag', itemId, this.inputForm[itemId])
    },
    // サジェストの表示
    dispSuggest: function(itemId) {
      this.initializeInput()
      this.initializeSuggest()
      this.displaySuggest[itemId] = true
      this.$forceUpdate()
    },
    // サジェストからの入力
    inputSuggest: function(itemId, tagId, tagName) {
      this.inputForm[itemId] = tagName
      this.displaySuggest[itemId] = false
      this.$forceUpdate()

      this.$emit('inputSuggest', itemId, tagId, tagName)
    },
    // サジェストの検索
    searchSuggest: function(itemId) {
      this.tagSuggest = Search.searchFromCollection(
        this.suggests,
        this.inputForm[itemId]
      )
    },
    // タグ入力のキャンセル
    cancel: function() {
      this.initializeInput()
      this.initializeSuggest()
      this.$forceUpdate()
    },
    // サジェストの初期化
    initializeSuggest: function() {
      this.tagSuggest = this.suggests
    },
    // 入力内容とサジェスト表示の初期化
    initializeInput: function() {
      this.inputForm = {}
      this.displaySuggest = {}
    },
  },
}
</script>
<style scoped>
.tag:after {
  border-left: none;
}
/* タグ入力 */
.list-group {
  margin-bottom: 0;
}
.input-form {
  display: inline-block;
}
.input-form > input {
  border: none;
  width: 150px;
  z-index: 999;
}
.suggest {
  position: absolute;
  width: 180px;
  z-index: 999;
  pointer-events: none;
}
.suggest-list {
  width: 150px;
  float: left;
}
.suggest a {
  pointer-events: auto;
}
.suggest .aut-but {
  font-size: 24px;
  background-color: #ffffff;
  padding: 2px;
  cursor: pointer;
}
</style>
